import apiClient from ".";
import { ConversationStatus, IConversation, IMessage, ObjectId, ISimpleMessage } from "../models";
import { APITool, IAgent, SystemTool } from "../models/agent";
import { IFAQ } from "../models/faq";
import { IFile } from "../models/file";
import { ITextBlock } from "../models/ITextblock";
import { IWebLink } from "../models/webLink";

// crud methods for Agentanization
export const createAgent = async (body: {
	name: string, 
	description: string, 
	orgId: ObjectId, 
	isPrivate: boolean
}) => {
	const response = apiClient.post<IAgent>(`/orgs/${body.orgId}/agents`, body);
	return response;
}
export const getAgent = async (body: {orgId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.get<IAgent>(`/orgs/${body.orgId}/agents/${body.id}`);
	return response.data;
};
export const getAgents = async (orgId: ObjectId) => {
	const response = await apiClient.get<IAgent[]>(`/orgs/${orgId}/agents`);
	return response.data;
}
export const updateAgent = async (body: {
	id: ObjectId,
	orgId: ObjectId,
	
	name?: string,
	description?: string,
	isPrivate?: boolean

	displayName?: string,
	greeting?: string,
	systemPrompt?: string,
	hidePoweredBy?: boolean,

	primaryColor?: string,
	useAdvancedFeatures?: boolean,
}) => {
	const response = await apiClient.patch<IAgent>(`/orgs/${body.orgId}/agents/${body.id}`, body);
	return response.data;
}
export const deleteAgent = async (body: {orgId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.delete<IAgent>(`/orgs/${body.orgId}/agents/${body.id}`);
	return response.data;
}
export const publishAgent = async (body: {orgId: ObjectId, id:ObjectId, renewkey?: boolean}) => {
	const response = await apiClient.post<IAgent>(`/orgs/${body.orgId}/agents/${body.id}/publish`, body);
	return response.data;
}
export const unPublishAgent = async (body: {orgId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.post<IAgent>(`/orgs/${body.orgId}/agents/${body.id}/unpublish`);
	return response.data;
}
export const updateAgentAvatar = async (body: {orgId: ObjectId, id: ObjectId, formData: FormData}) => {
	const {data} = await apiClient.patch(`/orgs/${body.orgId}/agents/${body.id}/avatar`, body.formData, 
		{ headers: { 'Content-Type': 'multipart/form-data' } }
	);
	return data;
}
export const updateAgentLauncher = async (body: {orgId: ObjectId, id: ObjectId, formData: FormData}) => {
	const {data} = await apiClient.patch(`/orgs/${body.orgId}/agents/${body.id}/launcher`, body.formData, 
		{headers: { 'Content-Type': 'multipart/form-data' } }
	);
	return data;
}

// textBlock
export const addTextBlock = async (body: {
	orgId: ObjectId, 
	agentId: ObjectId, 
	title: string, 
	text: string
}) => {	
	const response = await apiClient.post<ITextBlock>(`/orgs/${body.orgId}/agents/${body.agentId}/textBlocks`, body);
	return response.data;
}
export const getTextBlocks = async (body: { orgId: ObjectId, agentId: ObjectId}) => {
	const response = await apiClient.get<ITextBlock[]>(`/orgs/${body.orgId}/agents/${body.agentId}/textBlocks`);
	return response.data;
}
export const updateTextBlock = async (body: {
	orgId: ObjectId, 
	agentId: ObjectId,
	id: ObjectId,
	title: string, 
	text: string
}) => {
	const response = await apiClient.patch<ITextBlock>(`/orgs/${body.orgId}/agents/${body.agentId}/textBlocks/${body.id}`, body);
		return response.data;
}
export const deleteTextBlock = async (body: {
	orgId: ObjectId,
	agentId: ObjectId,
	id: ObjectId
}) => {
	const response = await apiClient.delete<ITextBlock>(`/orgs/${body.orgId}/agents/${body.agentId}/textBlocks/${body.id}`);
	return response.data;
}

// faq
export const addFaq = async (body: {orgId: ObjectId, agentId: ObjectId, question: string, answer : string}) => {
	const response = await apiClient.post<IFAQ>(`/orgs/${body.orgId}/agents/${body.agentId}/faqs`, body);
	return response.data;
}
export const getFaqs = async (body: { orgId: ObjectId, agentId: ObjectId}) => {
	const response = await apiClient.get<IFAQ[]>(`/orgs/${body.orgId}/agents/${body.agentId}/faqs`);
	return response.data;
}
export const updateFaq = async (body: {
	id: ObjectId, 
	question: string, 
	answer: string,
	agentId: ObjectId,
	orgId: ObjectId
}) => {
	const response = await apiClient.patch<IFAQ>(`/orgs/${body.orgId}/agents/${body.agentId}/faqs/${body.id}`, body);
	return response.data;
}
export const deleteFaq = async (body: {orgId: ObjectId, agentId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.delete<IFAQ>(`/orgs/${body.orgId}/agents/${body.agentId}/faqs/${body.id}`);
	return response.data;
}

//webLink
export const addWebLinks = async (body: {orgId: ObjectId, agentId: ObjectId, urls: string[]}) => {
	const response = await apiClient.post<IWebLink[]>(`/orgs/${body.orgId}/agents/${body.agentId}/webLinks`, body);
	return response.data;
}
export const getWebLinks = async (body: {orgId: ObjectId, agentId: ObjectId}) => {
	const response = await apiClient.get<IWebLink[]>(`/orgs/${body.orgId}/agents/${body.agentId}/webLinks`);
	return response.data;
}
export const refreshWebLink = async (body: {orgId: ObjectId, agentId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.put<IWebLink[]>(`/orgs/${body.orgId}/agents/${body.agentId}/webLinks/${body.id}/refresh`);
	return response.data;
}
export const updateWebLink = async (body: {
	id: ObjectId,
	orgId: ObjectId,
	agentId: ObjectId,
	text: string,
}) => {
	const response = await apiClient.patch<IWebLink>(`/orgs/${body.orgId}/agents/${body.agentId}/webLinks/${body.id}`, body);
	return response.data;
}
export const deleteWebLink = async (body: {
	orgId: ObjectId,
	agentId: ObjectId,
	id: string,
}) => {
	const response = await apiClient.delete<IWebLink>(`/orgs/${body.orgId}/agents/${body.agentId}/webLinks/${body.id}`);
	return response.data;
}

// file
export const uploadFiles = async (body: {orgId: ObjectId, agentId: ObjectId, formData: FormData}) => {
	const response = await apiClient.post<IFile[]>(
		`/orgs/${body.orgId}/agents/${body.agentId}/files`, 
		body.formData,
		{
			headers: { 'Content-Type': 'multipart/form-data' }
		}
	);
	return response.data;
}
export const getFiles = async (body: {orgId: ObjectId, agentId: ObjectId}) => {
	const response = await apiClient.get<IFile[]>(`/orgs/${body.orgId}/agents/${body.agentId}/files`);
	return response.data;
}
export const updateFile = async (body: {
	id: ObjectId,
	orgId: ObjectId,
	agentId: ObjectId,
	text: string,
}) => {
	const response = await apiClient.patch<IFile>(`/orgs/${body.orgId}/agents/${body.agentId}/files/${body.id}`,body);
	return response.data;
}
export const deleteFile = async (body: {
	orgId: ObjectId,
	agentId: ObjectId,
	id: string,
}) => {
	const response = await apiClient.delete<IFile>(`/orgs/${body.orgId}/agents/${body.agentId}/files/${body.id}`);
	return response.data;
}

// initiate train model
export const trainModelWithTextBlock = async (body:{orgId: ObjectId, agentId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.put(`/orgs/${body.orgId}/agents/${body.agentId}/textBlocks/${body.id}`);
	return response.data
}
export const trainModelWithWebLink = async (body:{orgId: ObjectId, agentId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.put(`/orgs/${body.orgId}/agents/${body.agentId}/webLinks/${body.id}`);
	return response.data
}
export const trainModelWithFile = async (body:{orgId: ObjectId, agentId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.put(`/orgs/${body.orgId}/agents/${body.agentId}/files/${body.id}`);
	return response.data
}
export const trainModelWithFaq = async (body:{orgId: ObjectId, agentId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.put(`/orgs/${body.orgId}/agents/${body.agentId}/faqs/${body.id}`);
	return response.data
}

// Chat bot
export const getChatAgent = async (accessKey:ObjectId) => {
	const response = await apiClient.get<IAgent>(`/chatagents/${accessKey}`);
	return response.data;
}
export const getChatTestResponse = async ( body: {
	orgId: ObjectId,
	agentId: ObjectId,
	chatHistory: ISimpleMessage[]
}) => {
	const response = await apiClient.post<{message: ISimpleMessage, sessionId: string, metadata: any}>(`/orgs/${body.orgId}/agents/${body.agentId}/chat`, body);
	return response.data;
}
export const getChatResponse = async (body:{
	accessKey: string,
	sessionId: string
	message: ISimpleMessage
}) => {
	const response = await apiClient.post<{message: ISimpleMessage, sessionId: string, metadata: any}>(`/chatagents/${body.accessKey}`, body);
	return response.data;
}

// WhatsApp
export const addWhatsAppCrendentials = async (body: {apiKey: string, accessToken: string, phoneNumberId: string}) => {
	const response = await apiClient.post<{verifyToken: string}>(`/whatsapp/add/${body.apiKey}`, body);
	return response.data;
}

// activity
export const getConversations = async (body: { orgId:ObjectId, agentId: ObjectId, limit?: number, page?: number}) => {
	const response = await apiClient.get<{rows: IConversation[], count: number}>(`/orgs/${body.orgId}/agents/${body.agentId}/activity`, 
	{
		params: {
			limit: body.limit,
			page: body.page
		}
	});
	return response.data;
}
export const updatedConversation = async (body: {orgId: ObjectId, agentId: ObjectId, conversationId: ObjectId, status: ConversationStatus}) => {
	const response = await apiClient.patch<IConversation>(`/orgs/${body.orgId}/agents/${body.agentId}/conversations/${body.conversationId}`, body);
	return response.data;
}
export const getMarktingData = async (body: { orgId:ObjectId, agentId: ObjectId, dateRange: {fromDate: Date, toDate: Date}}) => {
	const response = await apiClient.get<{conversations: IConversation[], messages: IMessage[]}>(`/orgs/${body.orgId}/agents/${body.agentId}/messages`,
		{
			params: body.dateRange
		}
	);
	return response.data;
}


// system tools
export const getSystemTools = async (orgId: ObjectId, agentId: ObjectId): Promise<SystemTool[]> => {
	const response = await apiClient.get<SystemTool[]>(`/orgs/${orgId}/agents/${agentId}/systemTools`);
	return response.data;
}
export const manageSystemTools = async (body: {orgId: ObjectId, agentId: ObjectId, toolId: string, enabled: boolean}): Promise<SystemTool> => {
	const response = await apiClient.patch(`/orgs/${body.orgId}/agents/${body.agentId}/systemTools/${body.toolId}`, body);
	return response.data;
}

// api tools
export const addApiTool = async (body: { orgId: ObjectId, agentId: ObjectId, tool: Omit<APITool, 'id' | 'createdAt' | 'updatedAt'>}): Promise<APITool> => {
	const response = await apiClient.post<APITool>(`/orgs/${body.orgId}/agents/${body.agentId}/apiTools`, body);
	return response.data;
}
export const getApiTools = async (orgId: ObjectId, agentId: ObjectId): Promise<APITool[]> => {
	const response = await apiClient.get<APITool[]>(`/orgs/${orgId}/agents/${agentId}/apiTools`);
	return response.data;
}
export const updateApiTool = async (body: { orgId: ObjectId, agentId: ObjectId, id: string, tool: APITool }): Promise<APITool> => {
	const response = await apiClient.patch<APITool>(`/orgs/${body.orgId}/agents/${body.agentId}/apiTools/${body.id}`, body);
	return response.data;
}
export const deleteApiTool = async (body: {orgId: ObjectId, agentId: ObjectId, toolId: string}) => {
	const response = await apiClient.delete(`/orgs/${body.orgId}/agents/${body.agentId}/apiTools/${body.toolId}`);
	return response.data;
}

